import styled from 'styled-components';
import FilterChip from './FilterChip';
import { quickFilters } from '../../constants';
import MoreIcon from '../../../../new-components/svg-icons/MoreIcon';
import { useDispatch, useSelector } from 'react-redux';
import FilterWithDropdown from './FilterWithDropdown';
import { useContext, useEffect } from 'react';
import {
  SearchContext,
  SearchContextInterface
} from '../../../search-new/context/SearchContext';
import { setQuickFilter } from '../../../../redux/slices/mapSlice';

const QuickFilters = () => {
  const drawerOpen = useSelector((state: any) => state.map.drawerOpen);
  const { showFilters } = useContext(SearchContext) as SearchContextInterface;
  const dispatch = useDispatch();

  useEffect(() => {
    if (showFilters) {
      dispatch(setQuickFilter(null));
    }
  }, [showFilters]);

  return (
    <Container className="hide-scrollbar" drawerOpen={drawerOpen}>
      {quickFilters.map(filter => (
        <FilterWithDropdown
          key={filter.label}
          type={filter.type}
          icon={filter.icon ? <filter.icon /> : null}
          label={filter.label}
        />
      ))}

      <FilterChip icon={<MoreIcon />} label="more_filters" />
    </Container>
  );
};

const Container = styled.div<{ drawerOpen: boolean }>`
  display: flex;
  gap: 8px;
  z-index: 9;
  margin-inline-end: ${props => props.drawerOpen && '550px'};

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    width: 100%;
    margin-top: 0px;
    margin-inline-end: 0;
    overflow-x: auto;
  }
`;

export default QuickFilters;
